<div class="chevron-wrapper left">
    @if (partDetailService.checkedRows.length > 1 && partDetailService.isMarkedRowWithDetails) {
        <sew-button class="chevron" hierarchy="tertiary" icon="arrow-chevron-left" show-icon-only>
            <button (click)="selectPrevious()"></button>
        </sew-button>
    }
</div>
@if (displayedSparePart | async; as markedRow) {
    <div class="flex-container">
        <div class="part-detail-content">
            <sew-headline class="sew-designation" level="3">{{ markedRow.rowData.name }}</sew-headline>
            <p class="part-number">
                {{
                    'ECS.PART_DETAIL.SUB_HEADER'
                        | translate
                            : {
                                  positionNumber: markedRow.rowData.itemNumber,
                                  partNumber: markedRow.rowData.id,
                              }
                }}
            </p>
            @switch (partDetailService.type) {
                @case ('description') {
                    <ecs-part-detail-description
                        [html]="markedRow.rowData.descriptionHtml"
                    ></ecs-part-detail-description>
                }
                @case ('cross_selling') {
                    @if (displayedSparePart | async; as displayedSparePart) {
                        <ecs-parts-recommendation
                            [checkedRows]="(checkedRows | async) ?? []"
                            [recommendationOrigin]="displayedSparePart"
                        ></ecs-parts-recommendation>
                    }
                }
            }
        </div>
    </div>
}
<div class="chevron-wrapper right">
    @if (partDetailService.checkedRows.length > 1 && partDetailService.isMarkedRowWithDetails) {
        <sew-button class="chevron" hierarchy="tertiary" icon="arrow-chevron-right" show-icon-only>
            <button (click)="selectNext()"></button>
        </sew-button>
    }
</div>
